export const CREDIT_CARD_ENDPOINT = '/credit-cards.mi';
export const ECM_ENDPOINT = '/credit-cards/existing-card-members.mi';

export const ECM_AEM_PRODUCT_SPECIFIC_SEO_ENDPOINT = '/credit-cards/existing-card-members';

export const RESOLVED_URL = {
  CHASE_CREDIT_CARD_URL: 'chase-credit-cards',
  AMEX_CREDIT_CARD_URL: 'american-express-credit-cards',
  CREDIT_CARD_URL: 'credit-cards',
} as const;

export const COBRAND_BLP_CARD_ROUTES: readonly string[] = [RESOLVED_URL.CHASE_CREDIT_CARD_URL];

/**
 * Application-level constants
 */
export const APPLICATION_CONSTANTS = {
  DEFAULT_LANG: 'en_US',
  DEFAULT_COUNTRY: 'US',
  APPLICATION_NAME: 'cobrand',
  EXPERIENCE_SEGMENT: ['NOT Logged In'],
  PAGE_LOADED: 'Page Loaded',
  PAGE_LOADING: 'Page Loading',
  ROUTING_CONFIG: 'routingConfig',
} as const;

/**
 * AEM item path constants
 */
export const AEM_PATHS = {
  ITEM_PATH_ROOT: 'root/responsivegrid',
  ITEM_PATH_HEADER: 'root/header-responsivegrid',
  ITEM_PATH_FOOTER: 'root/footer-responsivegrid',
} as const;
